import "./AddAttachment.css";
import React from "react";

const AddAttachment = ({
  handleCloseModal,
  attachmetTitle,
  setAttachmenttitle,
  attachmentLink,
  setAttachmetLink,
  selectedFile,
  setSelectedFile,
  isEdit,
  attachment,
  handleEdit,
  handleAdd,
  accept,
  progress = 0,
  isUploading = false,
}) => {
  const [invalidLink, setInvalidLink] = React.useState("");

  const validateUrl = (value) => {
    if (!value || value.trim() === "") {
      setInvalidLink("");
    } else if (!value.startsWith("https://")) {
      setInvalidLink("Please enter the full link with https.");
    } else {
      setInvalidLink("");
    }
  };

  React.useEffect(() => {
    if (!attachmetTitle && selectedFile) {
      setAttachmenttitle(selectedFile.name);
    }
  }, [selectedFile]);

  return (
    <div className=" assign-program excercise-modal assign-program trainings-modal mt-4 pt-4">
      <i className="fa fa-times" onClick={() => handleCloseModal()}></i>
      <p className="title-small">
        {`${isEdit ? "Edit" : "Add New"} Attachment`}
      </p>

      <div className="child-modal">
        <div className="message-body ">
          <div className="form-group mb-4">
            <label className="label">Title <span style={{color: 'red'}}>*</span></label>
            <input
              type="text"
              className="form-control input"
              value={
                isEdit && attachmetTitle == ""
                  ? attachment?.title
                  : attachmetTitle
              }
              onChange={(e) => {
                setAttachmenttitle(e.target.value);
              }}
            />
          </div>
          {isEdit && (
            <div className="attachment-alert">
              By Adding New Link or Selecting New File Your Pervious File & Link
              WIll be Removed
            </div>
          )}
          <div className="attachment-link-message">
            Please provide an attachment link if it’s already uploaded
            elsewhere, or you can upload it here.
          </div>
          <div className="form-group mb-2">
            <label className="label">Link</label>
            <input
              type="text"
              className="form-control input"
              value={attachmentLink}
              onChange={(e) => {
                setAttachmetLink(e.target.value);
                validateUrl(e.target.value);
              }}
            />
          </div>
          {invalidLink && attachmentLink != "" && (
            <div className="error-message ">{invalidLink}</div>
          )}
          <div className="attachment-link-message">
            <strong>OR</strong>
          </div>
          <div className="form-group mb-4">
            <label className="label">Upload File</label>
            <input
              className="file-selector form-control input"
              type="file"
              accept={accept}
              onChange={(e) => {
                setSelectedFile(e.target.files[0]);
              }}
              disabled={isUploading}
            />
            
            {/* Upload Progress */}
            {isUploading && selectedFile && (
              <div className="pw_upload-progress-container">
                <div className="pw_upload-info">
                  <div className="pw_upload-file-info">
                    <i className="fa fa-file"></i>
                    <span className="pw_file-name">{selectedFile.name}</span>
                  </div>
                  <span className="pw_progress-percentage">{progress}%</span>
                </div>
                <div className="pw_progress-bar-container">
                  <div 
                    className="pw_progress-bar-fill" 
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <div className="pw_upload-status">
                  <i className="fa fa-cloud-upload"></i>
                  <span>Uploading...</span>
                </div>
              </div>
            )}
            
            {/* File Preview */}
            {selectedFile && !isUploading && (
              <div className="pw_file-preview" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div className="pw_file-info" style={{display: 'flex', alignItems: 'center'}}>
                  <i className="fa fa-file"></i>
                  <div className="pw_file-details">
                    <span className="pw_file-name">{selectedFile.name}</span>
                    <span className="pw_file-size">
                      {(selectedFile.size / (1024 * 1024)).toFixed(2)} MB
                    </span>
                  </div>
                </div>
                <button 
                  className="pw_remove-file"
                  onClick={() => {
                    setSelectedFile(null);
                    // Also reset file input value
                    document.querySelector('.file-selector').value = null;
                  }}
                  
                  type="button"
                  style={{marginLeft: '16px'}}
                >
                </button>
              </div>
            )}
          </div>

          <div
            className={`file-size-message mb-2 ${
              selectedFile && selectedFile.size / (1024 * 1024) > 250 ? "error" : ""
            }`}
          >
            {selectedFile && selectedFile.size / (1024 * 1024) > 250
              ? `Your File size is : ` +
                (selectedFile.size / (1024 * 1024)).toFixed(2) +
                ` MB, it must be less than 250MB`
              : "File size should be less than 250MB"}
          </div>
        </div>
        <div className="d-flex justify-content-center mb-3">
          <button
            className={`button ${
              isUploading ? "disabled" :
              isEdit
                ? attachmetTitle || selectedFile || attachmentLink
                  ? ""
                  : "disabled"
                : attachmetTitle && (selectedFile || attachmentLink)
                ? ""
                : "disabled"
            }`}
            onClick={() => {
              if (!isUploading) {
                isEdit ? handleEdit() : handleAdd();
                // Don't close modal here - let the parent component handle it after upload completes
              }
            }}
            disabled={isUploading}
          >
            {isUploading ? (
              <>
                <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                Uploading...
              </>
            ) : (
              isEdit ? "Update Attachment" : "Add Attachment"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAttachment;
